/**
 * Created by Bart Decorte
 * Date: 16/04/2020
 * Time: 16:04
 */
import * as Ladda from "ladda";

export default class SubmitButtonManager {
  constructor(params) {
    this.defaults = {
      buttonSelector: '', // Query selectors we're handling the submit buttons for
      $form: undefined, // Form those buttons are triggering
      stateEmitter: undefined, // Event emitter: whatever object we're waiting for to finish
      successStateEvent: 'idle', // Event of that emitter we're waiting for to actually submit the form
      onActualSubmit: () => {}, // The callback that's executed when the form can be actually submitted
    };
    this.params = { ...this.defaults, ...params };
    this.buttons = {};
    this.initButtons();
    this.bindListeners();
  }

  initButtons() {
    const saveButtons = document.querySelectorAll(this.params.buttonSelector);
    saveButtons.forEach((button) => {
      button.dataset.style = 'zoom-in';
      let type = button.dataset.type;
      this.buttons[type] = this.buttons[type] || [];
      this.buttons[type].push(Ladda.create(button));
    });
  }

  bindListeners() {
    $(this.params.buttonSelector).on('click', (ev) => {
      return this.lButtonClicked(ev);
    });
  };

  lButtonClicked(ev) {
    const $button = $(ev.target).parents('a, button').first();
    const buttonType = $button.data('type');
    const saveType = $button.val();
    this.submitWhenIdle(buttonType, saveType);
  };

  invokeOnButtons(which, func) {
    this.buttons[which].forEach((button) => {
      button[func]();
    });
  }

  setButtonsDisabled(isDisabled = true) {
    const buttons = document.querySelectorAll(this.params.buttonSelector);
    buttons.forEach(button => {
      if (button.tagName === 'A') {
        if (isDisabled) {
          button.classList.add('disabled')
        } else {
          button.classList.remove('disabled')
        }
      } else {
        if (isDisabled) {
          button.setAttribute('disabled', '');
        } else {
          button.removeAttribute('disabled');
        }
      }
    });
  }

  submitWhenIdle(buttonType = 'save', saveType = '') {
    this.setSubmitValue(saveType);
    this.invokeOnButtons(buttonType, 'start');
    this.setButtonsDisabled();

    if (this.params.stateEmitter.isIdle()) {
      this.params.onActualSubmit();
    } else {
      this.params.stateEmitter.on(this.params.successStateEvent, () => {
        this.params.onActualSubmit();
      });
    }
  }

  setSubmitValue(submitValue) {
    const $submit = this.params.$form.find('[name="submit"]');

    if ($submit.length) {
      $submit.val(submitValue);
    }

    return this;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/SubmitButtonManager.js